import React, { useEffect, useMemo, useRef, useState } from "react";
import {
    Area,
    Bar,
    BarChart,
    CartesianGrid,
    Cell,
    ComposedChart,
    LabelList,
    Legend,
    Line,
    LineChart,
    ReferenceLine,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from "recharts";
import { useSelector } from "react-redux";
import { useDemandInventoryLineGraphData, useGetInactiveInventoryPlantLevelData, useGetInventoryHajocaDemoChanges, useInactiveInventoryWaterfallData, usePotentialOverstockLineGraphData } from "../../services/redux/hooks/useInventory";
import { IDemandPurchase, IInventoryTrend, ILTTrend, InventoryGraphPayload, IPotentialStockOutInventoryTrend } from "../../services/interface/IAlerts";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { IDOHData } from "../../services/interface/IForecast";
import { formatNumber, formatter } from "../../utils/formatter";
import { IRoot } from "../../services/interface/IHome";
import cluster from "cluster";
const DEVALUED_RED = '#ff4b4b';


const LineGraph = (props: any) => {
    const prevPayloadRef = useRef<any>();
    const location = useLocation();
    const alertType = new URLSearchParams(location.search).get("alert");
    const updatedAlert = String(alertType)?.charAt(0).toLowerCase() + alertType?.slice(1) || "";
    const selectedGBPFilter = useSelector((state: IRoot) => state.filter.selectedGBPFilter);
    const applyFilter = useSelector((state:IRoot)=>state.filter.applyFilter);
    const plant = useSelector((state: IRoot)=>state.filter.selectedGBPFilter.plant);
    const material = useSelector((state: IRoot)=>state.filter.selectedGBPFilter.material);
    const selectedClustername = useSelector((state: IRoot)=>state.filter.selectedClustername);

    // Existing state
    const [isActive, setIsActive] = useState<number>(0);
    const [invGraphPayload, setInvGraphPayload] = useState<any>({
        alertType: updatedAlert,
        clustername: [],
        futureSegmentation: [],
        l2: [],
        l3: [],
        material: [],
        materialDescription: [],
        mrpType: [],
        plant: [],
        vendorName: [],
        alerts: ["AgeingInventory"],
    });

    // Existing data state
    const [graphDataAge, setGraphDataAge] = useState();
    const [vendorAgeData, setVendorAgeData] = useState();
    const [dohData, setDohData] = useState<any[]>();

    // NEW: Flag=3 drill-through state
    const [currentView, setCurrentView] = useState<'summary' | 'age' | 'devalued' | 'priceline'>('summary');
    const [selectedCategory, setSelectedCategory] = useState<string>('overall');
    const [summaryData, setSummaryData] = useState<any[]>([]);
    const [ageData, setAgeData] = useState<any[]>([]);
    const [devaluedData, setDevaluedData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    // Existing API hooks
    const { mutate: mutateAgeingInventory, isSuccess, isError, data: ageingInventoryData } = useInactiveInventoryWaterfallData();
    const { mutate: mutatePlantInventory, isSuccess: isPlantSuccess, data: ageingPlantData } = useGetInactiveInventoryPlantLevelData();
    
    // NEW: Your API hook for flag=3
    const { mutate: mutateInventoryHajocaDemoChanges, isSuccess: isInventoryHajoca, data: inventoryHajocaData } = useGetInventoryHajocaDemoChanges();

    const [isCustomData, setIsCustomData] = useState(false);

    const customPlantInventoryData: any = {
        "861582403U": [
            { "OnHand": 56775, "Plant": "DC 2", "doh": 20 },
            { "OnHand": 132131, "Plant": "DC 8", "doh": 40 },
        ],
        "802411574U": [
            { "OnHand": 30303, "Plant": "DC 1", "doh": 40 },
            { "OnHand": 12891, "Plant": "DC 8", "doh": 33 }
        ],
        "885858794U": []
    };

    // NEW: Prepare data for flag=3 summary view
const prepareSummaryData = (response: any) => {
    if (response?.data && Array.isArray(response.data)) {
        setSummaryData(response.data);
    } else {
        console.error('Invalid summary data structure:', response);
        setSummaryData([]);
    }
};

    // NEW: Prepare data for flag=3 age view
    const prepareAgeData = (response: any) => {
        // if (!data?.data) return;
        
        // const formattedData = data.data.map((item: any) => ({
        //     label: item.label,
        //     qty: item.qty || 0,
        //     dollar: item.dollar || 0,
        //     devaluedFinal: item.devaluedFinal || 0
        // }));
        
        // setAgeData(formattedData);

    if (response?.data && Array.isArray(response.data)) {
        setAgeData(response.data);
    } else {
        console.error('Invalid summary data structure:', response);
        setAgeData([]);
    }
    };

    // NEW: Prepare data for flag=3 devalued view
    const prepareDevaluedData = (response: any) => {
        // if (!data?.data) return;
        
        // const formattedData = data.data.map((item: any) => ({
        //     groupKey: item.groupKey,
        //     devaluedBy: item.devaluedBy || 0,
        //     devaluedFinal: item.devaluedFinal || 0
        // }));
        
        // setDevaluedData(formattedData);
      if (response?.data && Array.isArray(response.data)) {
          setDevaluedData(response.data);
      } else {
          console.error('Invalid summary data structure:', response);
          setDevaluedData([]);
      }
        
    };

    // Existing data preparation functions
    const prepareWaterfallData = (data: any) => {
        const { taggedData, timeframeData, taggedData1, timeframeData1 } = data;
        let obj1: any = new Object();

        timeframeData1?.forEach((value: any) => {
          if (obj1.hasOwnProperty(value?.plant_code)) {
            if (value?.InventoryAgeBuckets === ">12Months") {
              obj1[value?.plant_code].M8 += value?.onhand;
            } else {
              obj1[value?.plant_code].M812 += value?.onhand;
            }
            obj1[value?.plant_code].sum += value?.onhand;
          } else {
            obj1[value?.plant_code] = {
              cluster: value?.plant_code,
              M8: value?.InventoryAgeBuckets === ">12Months" ? value?.onhand : 0,
              M812: value?.InventoryAgeBuckets === "8-12Months" ? value?.onhand : 0,
              sum: value?.onhand,
            };
          }
        });

        let finalData3: any = [];
        for (let key in obj1) {
          finalData3.push(obj1[key]);
        }
        finalData3.sort((a: any, b: any) => b?.sum - a?.sum);
        setGraphDataAge(finalData3);

        let obj4: any = new Object();
        taggedData?.forEach((value: any) => {
          if (obj4.hasOwnProperty(value?.Vendor_Code)) {
            if (value?.InventoryAgeBuckets === ">12Months") {
              obj4[value?.Vendor_Code].M8 += value?.onhand;
            } else {
              obj4[value?.Vendor_Code].M812 += value?.onhand;
            }
            obj4[value?.Vendor_Code].sum += value?.onhand;
          } else {
            obj4[value?.Vendor_Code] = {
              cluster: value?.Vendor_Code,
              M8: value?.InventoryAgeBuckets === ">12Months" ? value?.onhand : 0,
              M812: value?.InventoryAgeBuckets === "8-12Months" ? value?.onhand : 0,
              sum: value?.onhand,
            };
          }
        });

        let finalData5: any = [];
        for (let key in obj4) {
          finalData5.push(obj4[key]);
        }
        finalData5.sort((a: any, b: any) => b?.sum - a?.sum);
        setVendorAgeData(finalData5);
    };

    const prepareDOHData=(data:any)=>{
      let finalData:IDOHData[]=[];
      Array.isArray(data) && data.map((each:IDOHData)=>{
        let obj = {
          doh: each.doh ?? 0,
          onhand: each.onhand ?? 0,
          plant_code: each.plant_code ?? 0
        }
        finalData.push(obj);
      });
      setDohData(finalData);
    }

    const preparePlantDOHData=(data:any)=>{
      let finalData:IDOHData[]=[];
      Array.isArray(data) && data.map((each:any)=>{
        if(each.doh){
          let obj = {
            doh: each.doh,
            onhand: each.OnHand,
            plant_code: each.Plant
          }
          finalData.push(obj);
        }
      });
      setDohData(finalData);
    }

    // NEW: API call functions for flag=3
    const fetchSummaryData = () => {
        setLoading(true);
        const payload = {
            view: "summary",
            ...selectedGBPFilter
        };
        mutateInventoryHajocaDemoChanges(payload);
    };

    const fetchAgeData = (category: string) => {
        setLoading(true);
        const payload = {
            view: "age",
            selection: category,
            ...selectedGBPFilter
        };
        mutateInventoryHajocaDemoChanges(payload);
    };

const fetchPriceLineData = (selection: string, ageSelection: string) => {
    setLoading(true);
    const payload = { 
        view: "priceline",     // Changed from "devalued" 
        selection: selection,
        ageSelection: ageSelection,  // e.g., "8-12-months"
        ...selectedGBPFilter 
    };
    mutateInventoryHajocaDemoChanges(payload);
};

    // NEW: Click handlers for drill-through
// Fix the click handler data access
const handleSummaryClick = (data: any, index: number) => {
    if (props.flag !== 3 || !data || !data.activePayload) return;

    const clickedData = data.activePayload.find((item: any) => item.payload && item.payload.categoryKey);

    if (!clickedData || !clickedData.payload.categoryKey) return;

    const category = clickedData.payload.categoryKey; // Use categoryKey from API

    console.log('Selected category:', category);
    if (category !== 'inactive') return;

    setSelectedCategory(category);

    setCurrentView('age');

    fetchAgeData(category);

};
// prefers the visible segment (not the transparent base)
const handleAgeClick = (evt: any) => {
  if (props.flag !== 3) return;

  const payloads = evt?.activePayload;
  if (!Array.isArray(payloads) || payloads.length === 0) return;

  const seg =
    [...payloads].reverse().find((p: any) => p?.dataKey && p.dataKey !== 'base' && p.value != null)
    || payloads.find((p: any) => p?.dataKey && p.dataKey !== 'base');

  const payload = seg?.payload;
  const categoryKey = payload?.categoryKey;
  if (!categoryKey) return;

  const scheme = payload?.isTotal
    ? AGE_COLOR_MAP['inactive-inventory'] // { main: gray, devalued: red }
    : (AGE_COLOR_MAP[categoryKey] ?? { main: AGE_GRAY, devalued: DEVALUED_RED });

  setPriceLineColors(scheme);

  const ageSelection = payload?.isTotal ? undefined : categoryKey;

  setCurrentView('priceline');
  fetchPriceLineData(selectedCategory, ageSelection);
};

    // NEW: Back button handlers
    const handleBackToSummary = () => {
        setCurrentView('summary');
        setSelectedCategory('overall');
    };

    const handleBackToAge = () => {
        setCurrentView('age');
    };

    // NEW: Get dynamic title for flag=3
const getDynamicTitle = () => {
  if (props.flag !== 3) return props.title;
  switch (currentView) {
    case 'summary': return 'Overall Inventory Breakdown';
    case 'age':     return 'Inactive Inventory Breakdown by Age';
    case 'priceline': return 'Inventory Breakdown by Priceline';
    default:        return props.title;
  }
};

    // Existing useEffects
    useEffect(() => {
        if (selectedClustername?.length > 0) {
            const materialKey = (material as any) && (material as any).length > 0 ? (material as any)[0] : null;
            if (materialKey && customPlantInventoryData[materialKey]) {
                preparePlantDOHData(customPlantInventoryData[materialKey]);
                return; 
            }
            const payload = {
                "cluster": selectedClustername,
                "material": material
            };
            mutatePlantInventory(payload);
        }
    }, [selectedClustername, material]);

    useEffect(() => {
        if(applyFilter.status || applyFilter.rowNo===-1){
            if (props.flag === 3) {
                // NEW: For flag=3, fetch summary data initially
                fetchSummaryData();
            } else {
                // Existing logic for flag=1,2
                const payload = {
                    ...invGraphPayload,
                    ...selectedGBPFilter,
                    alertType:2
                }
                mutateAgeingInventory(payload);
            }
        }
    }, [applyFilter, alertType]);

    useEffect(() => {
        const materialKey = (material as any) && (material as any).length > 0 ? (material as any)[0] : null;
        if (isPlantSuccess && (!materialKey || !customPlantInventoryData[materialKey])) {
            preparePlantDOHData(ageingPlantData?.data);
        }
    }, [ageingPlantData?.data, material]);

    useEffect(() => {
      if(isSuccess && selectedClustername.length<=0){
            prepareDOHData(ageingInventoryData?.dohData);
      }
      if(isSuccess){
        prepareWaterfallData(ageingInventoryData);
      }
    }, [ageingInventoryData]);

    // NEW: Handle API response for flag=3
    useEffect(() => {
        if (isInventoryHajoca && inventoryHajocaData) {
            setLoading(false);
            
            switch (inventoryHajocaData.view) {
                case 'summary':
                    prepareSummaryData(inventoryHajocaData);
                    break;
                case 'age':
                    prepareAgeData(inventoryHajocaData);
                    break;
                case 'priceline':
                    prepareDevaluedData(inventoryHajocaData);
                    break;
            }
        }
    }, [isInventoryHajoca, inventoryHajocaData]);

    // format to Millions with 2 decimals (Qty)
const fmtM2 = (v: any) => `${(Number(v || 0) / 1_000_000).toFixed(2)}M`;

// format currency in Millions with 2 decimals
const fmtMoneyM2 = (v: any) => `$${(Number(v || 0) / 1_000_000).toFixed(2)}M`;

// X-axis label shortener: remove "Inventory", rename "Remaining" -> "Active"
const shortLabel = (label: string) => {
  if (!label) return label;
  const l = label.replace(/Inventory/gi, '').trim();
  if (/^Remaining$/i.test(l)) return 'Active';
  if (/^Remaining\s*$/i.test(label)) return 'Active';
  return l;
};
const ChartLegend = ({ items }: { items: { label: string; color: string }[] }) => (
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center', padding: '4px 0 6px', marginTop: "-15px" }}>
    {items.map((it, i) => (
      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ width: 8, height: 8, background: it.color, borderRadius: 2, display: 'inline-block' }} />
        <span className="font-semibold" style={{color: it.color}}>{it.label}</span>
      </div>
    ))}
  </div>
);
// Helpers
const clampNonNeg = (n: number) => Math.max(0, Number(n) || 0);

const COLORS = {
  blue: '#1f77b4',
  red: '#ff4b4b',
  green: '#00b050',
  redTwo: '#cb847f',
  gray: '#98A2B3',
};

const renderSummaryChart = () => {
  // API data
  const overallVal   = clampNonNeg(summaryData?.[0]?.onHandValue);
  const overallDevBy = clampNonNeg(summaryData?.[0]?.devaluedQty);     // “devaluedBy $” (from API “devaluedQty”)
  const inactiveVal  = clampNonNeg(summaryData?.[1]?.onHandValue);
  const inactiveDev  = clampNonNeg(summaryData?.[1]?.devaluedValue);   // final devalued $
  const potVal       = clampNonNeg(summaryData?.[2]?.onHandValue);
  const activeVal    = clampNonNeg(summaryData?.[3]?.onHandValue);

  // Main portions (bar height = main + gray slice)
  const overallMain  = Math.max(overallVal - overallDevBy, 0);
  const inactiveMain = Math.max(inactiveVal - inactiveDev, 0);

  // TRUE waterfall bases
  const baseOverall  = 0;
  const baseInactive = overallVal - inactiveVal;
  const basePotInact = overallVal - inactiveVal - potVal;
  const baseActive   = 0; // final shows as standalone

  // Build data rows (each row already contains the exact numbers for the tooltip)
  const waterfallData = [
    {
      name: 'Overall',
      categoryKey: summaryData?.[0]?.categoryKey || 'overall',
      base: baseOverall,
      value: overallMain,
      devaluedValue: overallDevBy,            // gray slice
      mainColor: COLORS.blue,
      devColor: COLORS.red,
      onHandQty: summaryData?.[0]?.onHandQty,
      onHandValue: overallVal,
      devaluedQty: summaryData?.[0]?.devaluedQty,       // $ reduced (naming legacy from API)
      tooltip: summaryData?.[0]?.tooltip,
      Qty_DevaluedByTooltip: summaryData?.[0]?.Qty_DevaluedByTooltip, 
    },
    {
      name: 'Inactive',
      categoryKey: summaryData?.[1]?.categoryKey || 'inactive',
      base: baseInactive,
      value: inactiveMain,
      devaluedValue: inactiveDev,             // gray slice
      mainColor: COLORS.gray,
      devColor: COLORS.red,
      onHandQty: summaryData?.[1]?.onHandQty,
      onHandValue: inactiveVal,
      devaluedQty: summaryData?.[1]?.devaluedQty,
      tooltip: summaryData?.[1]?.tooltip,
      Qty_DevaluedByTooltip: summaryData?.[0]?.Qty_DevaluedByTooltip, 
    },
    {
      name: 'Potential Inactive',
      categoryKey: summaryData?.[2]?.categoryKey || 'potential-inactive',
      base: basePotInact,
      value: potVal,
      devaluedValue: 0,                        // no gray slice
      mainColor: COLORS.redTwo,
      devColor: 'transparent',
      onHandQty: summaryData?.[2]?.onHandQty,
      onHandValue: potVal,
      devaluedQty: 0,
      tooltip: summaryData?.[2]?.tooltip,
      Qty_DevaluedByTooltip: summaryData?.[2]?.Qty_DevaluedByTooltip, 
    },
    {
      name: 'Active',
      categoryKey: summaryData?.[3]?.categoryKey || 'remaining',
      base: baseActive,
      value: activeVal,
      devaluedValue: 0,                        // no gray slice
      mainColor: COLORS.green,
      devColor: 'transparent',
      onHandQty: summaryData?.[3]?.onHandQty,
      onHandValue: activeVal,
      devaluedQty: 0,
      tooltip: summaryData?.[3]?.tooltip,
      Qty_DevaluedByTooltip: summaryData?.[3]?.Qty_DevaluedByTooltip, 
    },
  ];

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={waterfallData}
        onClick={handleSummaryClick}
        style={{ cursor: 'pointer' }}
        margin={{ top: 8, right: 24, left: 0, bottom: 0 }}
        barCategoryGap="24%"
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis
          dataKey="name"
          fontSize="0.9vw"
          stroke="#949494"
        />
        <Tooltip content={<CustomTooltipGraph1 />} />
        <Legend
          verticalAlign="top"
          align="right"
          content={
            <ChartLegend
              items={[
                // { label: 'Overall',           color: COLORS.blue },
                // { label: 'Inactive',          color: COLORS.red },
                { label: 'Devalued Inventory',          color: COLORS.red },
                // { label: 'Potential Inactive',color: COLORS.redTwo },
                // { label: 'Active',            color: COLORS.green },
              ]}
            />
          }
        />

        {/* Waterfall positioning */}
        <Bar dataKey="base" fill="transparent" stackId="stack" barSize={36} />

        {/* Main visible segments */}
        <Bar dataKey="value" stackId="stack" name="Main" barSize={36} isAnimationActive={false}>
          {waterfallData.map((entry, index) => (
            <Cell key={`main-${index}`} fill={entry.mainColor} />
          ))}
        </Bar>

        {/* Gray devalued segments for Overall & Inactive */}
        <Bar dataKey="devaluedValue" stackId="stack" name="Devalued" barSize={36} isAnimationActive={false}>
          {waterfallData.map((entry, index) => (
            <Cell key={`dev-${index}`} fill={entry.devColor} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

const CustomTooltipGraph1 = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  // Prefer a visible segment (not the transparent base)
  const seg =
    [...payload].reverse().find((p: any) => p?.dataKey !== 'base' && p?.payload) || payload[0];
  const data = seg?.payload;
  
  if (!data) return null;
  const onHandQty = data.onHandQty ?? 0;
  const onHandVal = data.onHandValue ?? data.value ?? 0;
  const devQty = data.devaluedQty ?? 0;
  const devVal = data.devaluedValueRaw ?? data.devaluedValue ?? 0;
  const qtyDevalued = (data.Qty_DevaluedByTooltip ?? 0);
  return (
    <div className="custom-tooltip" style={{ background: 'white', padding: 12, border: '1px solid #ccc', borderRadius: 6, boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
      <p style={{ margin: '0 0 8px 0', fontWeight: 700, fontSize: 14 }}>{shortLabel(label)}</p>
      <p style={{ margin: 0, fontSize: 12 }}><strong>OnHand (Qty):</strong> {fmtM2(onHandQty)}</p>
      <p style={{ margin: 0, fontSize: 12 }}><strong>OnHand ($):</strong> {fmtMoneyM2(onHandVal)}</p>
      <p style={{ margin: 0, fontSize: 12 }}><strong>Devalued (Qty):</strong> {fmtM2(qtyDevalued)}</p>
      <p style={{ margin: 0, fontSize: 12 }}><strong>Devalued ($):</strong> {fmtMoneyM2(devQty)}</p>
    </div>
  );
};
// shared gray
// Colors
const AGE_GRAY = '#98A2B3';

// Single definition (remove any duplicates later in the file)
const AGE_COLOR_MAP: Record<string, { main: string; devalued: string; legend: string }> = {
  'inactive-inventory': { main: AGE_GRAY, devalued: DEVALUED_RED, legend: 'Inactive Inventory' }, // total
  '8-12-months':       { main: AGE_GRAY, devalued: DEVALUED_RED, legend: '8-12 Months' },
  '12-18-months':      { main: AGE_GRAY, devalued: DEVALUED_RED, legend: '12-18 Months' },
  '>18-months':        { main: AGE_GRAY, devalued: DEVALUED_RED, legend: '>18 Months' },
};

// Default priceline colors must match the scheme
const [priceLineColors, setPriceLineColors] = useState<{ main: string; devalued: string }>(
  { main: AGE_GRAY, devalued: DEVALUED_RED }
);
const n = (v: any) => (v == null || v === '' ? 0 : Number(v));

// Build waterfall data (only change is clamping the final base)
const renderAgeChart = () => {
  const allRaw = Array.isArray(ageData) ? ageData : [];
  const all = [...allRaw].sort((a: any, b: any) => n(a.sortOrder) - n(b.sortOrder));

  const totalRow = all.find((r: any) => r.categoryKey === 'inactive-inventory') ?? all[0] ?? {};
  const buckets  = all.filter((r: any) => r !== totalRow);

  // API fields
  const totalGross = n(totalRow.onHandValue);
  const totalDev   = n(totalRow.devaluedValue);   // write-off ($)
  const totalNet   = n(totalRow.netValue);        // after devaluation

  let prevTop = totalGross;
  const wf: any[] = [];

// 1) Total bar (Inactive)
wf.push({
  name: AGE_COLOR_MAP['inactive-inventory'].legend,
  categoryKey: 'inactive-inventory',
  base: 0,
  mainValue: Math.max(totalNet, 0),         // net (gray)
  devaluedValue: Math.max(totalDev, 0),     // write-off (red)
  mainColor: AGE_COLOR_MAP['inactive-inventory'].main, // -> AGE_GRAY
  devColor: AGE_COLOR_MAP['inactive-inventory'].devalued, // -> DEVALUED_RED
  isTotal: true,
  onHandQty: n(totalRow.onHandQty),
  onHandValue: totalGross,
  netValue: totalNet,
  tooltip: totalRow?.tooltip || 'Total inactive inventory breakdown',
  Qty_DevaluedByTooltip: totalRow?.Qty_DevaluedByTooltip,
});

// 2) Age buckets
buckets.forEach((item: any) => {
  const key   = item?.categoryKey;
  const gross = n(item.onHandValue);
  const dev   = n(item.devaluedValue);
  const net   = n(item.netValue);
  const base  = prevTop - gross;

  const scheme = AGE_COLOR_MAP[key] ?? { main: AGE_GRAY, devalued: DEVALUED_RED };

  wf.push({
    name: item?.category || item?.label,
    categoryKey: key,
    base,
    mainValue: Math.max(net, 0),
    devaluedValue: Math.max(dev, 0),
    mainColor: scheme.main,         // -> AGE_GRAY
    devColor: scheme.devalued,      // -> DEVALUED_RED
    onHandQty: n(item.onHandQty),
    onHandValue: gross,
    netValue: net,
    tooltip: item?.tooltip || `${item?.category || item?.label} breakdown`,
    Qty_DevaluedByTooltip: item?.Qty_DevaluedByTooltip,
  });

  prevTop = base;
});

  // Clamp last column to zero baseline
  const last = wf[wf.length - 1];
  if (last) last.base = 0;

  return (
    <ResponsiveContainer width="100%" height={'100%'}>
      <BarChart
        data={wf}
        onClick={handleAgeClick}
        style={{ cursor: 'pointer' }}
        margin={{ top: -6, right: 24, left: 0, bottom: 8 }}
        barCategoryGap="10%"
        barGap={4}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis dataKey="name" fontSize="0.8vw" stroke="#949494" tickFormatter={(v) => shortLabel(String(v))} />
        <Tooltip content={<CustomTooltipGraph2 />} />
        <Legend
          verticalAlign="top"
          align="left"
          content={
            <ChartLegend
              items={[
                { label: 'Devalued Inventory', color: DEVALUED_RED },
              ]}
            />
          }
        />

<Bar dataKey="base" fill="transparent" stackId="wf" barSize={36} />
{/* Net (main) -> gray */}
<Bar dataKey="mainValue" stackId="wf" name="Inactive Inventory" barSize={36} isAnimationActive={false}>
  {wf.map((e: any, i: number) => <Cell key={`m-${i}`} fill={e.mainColor} />)}
</Bar>
{/* Devalued (write-off) -> red when > 0 */}
<Bar
  dataKey="devaluedValue"
  stackId="wf"
  name="Devalued Inventory"
  barSize={36}
  isAnimationActive={false}
>
  {wf.map((e: any, i: number) => (
    <Cell
      key={`d-${i}`}
      fill={e.devaluedValue > 0 ? e.devColor : 'transparent'}
      stroke="transparent"
    />
  ))}
</Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};
// Tooltip for Age: show all 4 values (Millions, $)
const CustomTooltipGraph2 = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  const visible = payload.filter((p: any) => p?.dataKey && p.dataKey !== 'base');
  const seg =
    [...payload].reverse().find((p: any) => p?.dataKey && p.dataKey !== 'base' && p?.payload) ||
    payload[0];
  const data = seg?.payload;
  if (!data) return null;

  const onHandQty = data.onHandQty ?? 0;
  const onHandVal = data.onHandValue ?? (Number(data.mainValue || 0) + Number(data?.devaluedValueRaw || data.devaluedValue || 0));
  const devQty = data.devaluedQty ?? 0;
  const devVal = data.devaluedValue ?? 0;
  const qtyDevalued = (data.Qty_DevaluedByTooltip ?? 0);
  return (
    <div className="custom-tooltip" style={{ background: 'white', padding: 12, border: '1px solid #ccc', borderRadius: 6, boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
      <p style={{ margin: '0 0 8px 0', fontWeight: 700, fontSize: 14 }}>{shortLabel(label)}</p>
      <p style={{ margin: 0, fontSize: 12 }}><strong>OnHand (Qty):</strong> {fmtM2(onHandQty)}</p>
      <p style={{ margin: 0, fontSize: 12 }}><strong>OnHand ($):</strong> {fmtMoneyM2(onHandVal)}</p>
      <p style={{ margin: 0, fontSize: 12 }}><strong>Devalued (Qty):</strong> {fmtM2(qtyDevalued)}</p>
      <p style={{ margin: 0, fontSize: 12 }}><strong>Devalued ($):</strong> {fmtMoneyM2(devVal)}</p>
    </div>
  );
};


function shortLabelSummary(label: string): string {
  // Keep full "PC X" labels intact
  if (label.startsWith('PC ')) return label;

  // Truncate longer labels (e.g., "PriceLine 8" → "Pl 8")
  return label
    .replace('PriceLine', 'PL')
    .replace(' inactive', '')
    .substring(0, 10); // Adjust length as needed
}
const renderPriceLineChart = () => {
  const rows = (devaluedData || []).map((item: any) => ({
    name: item.category || item.groupKey,
    categoryKey: item.categoryKey || item.groupKey,

    // API-aligned fields
    netValue: n(item.netValue),               // after devaluation
    devaluedValue: n(item.devaluedValue),     // write-off $
    onHandQty: n(item.onHandQty),
    onHandValue: n(item.onHandValue),

    // optional passthroughs for tooltips
    tooltip: item.tooltip,
    Qty_DevaluedByTooltip: n(item.Qty_DevaluedByTooltip),
  }));

  return (
    <ResponsiveContainer width="100%" height={"100%"}>
      <BarChart data={rows} margin={{ top: -6, right: 24, left: 0, bottom: 8 }} barCategoryGap="20%" barGap={6}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis dataKey="name" fontSize="0.8vw" stroke="#949494" tickFormatter={(v) => shortLabelSummary(String(v))} />
        <Tooltip cursor={{ fill: 'transparent' }} content={<CustomTooltipPriceLine />} />
        <Legend
          verticalAlign="top"
          align="left"
          content={
            <ChartLegend
              items={[
                { label: 'Devalued Inventory', color: priceLineColors.devalued },
              ]}
            />
          }
        />

      <Bar dataKey="netValue" stackId="pl" fill={priceLineColors.main} name="Inactive Inventory" barSize={36} />
      {/* Write-off amount -> red */}
      <Bar dataKey="devaluedValue" stackId="pl" fill={priceLineColors.devalued} name="Devalued Inventory" barSize={36} />
      </BarChart>
    </ResponsiveContainer>
  );
};

const CustomTooltipPriceLine = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  const seg = payload.find((p: any) => p?.payload)?.payload;
  if (!seg) return null;
  

  return (
    <div className="custom-tooltip" style={{ background: 'white', padding: 12, border: '1px solid #ccc', borderRadius: 6, boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
      <p style={{ margin: '0 0 8px 0', fontWeight: 700, fontSize: 14 }}>{shortLabel(label)}</p>
      <p style={{ margin: 0, fontSize: 12 }}><strong>OnHand (Qty):</strong> {fmtM2(seg.onHandQty)}</p>
      <p style={{ margin: 0, fontSize: 12 }}><strong>OnHand ($):</strong> {fmtMoneyM2(seg.onHandValue)}</p>
      <p style={{ margin: 0, fontSize: 12 }}><strong>Devalued (Qty):</strong> {fmtM2(seg.Qty_DevaluedByTooltip)}</p>
      <p style={{ margin: 0, fontSize: 12 }}><strong>Devalued ($):</strong> {fmtMoneyM2(seg.devaluedValue)}</p>
    </div>
  );
};


    return (
        <div className="w-[100%] h-[100%] bg-[#FFF] shadow rounded px-[2%] py-[12px] border-[1px] border-[#BEBEBE] flex flex-col">
            <div className="flex justify-between items-center mb-[0.5vw]">
                <span className="text-mainGreen font-semibold chart-title self-start">
                    {props.flag === 3 ? getDynamicTitle() : 
                     `${isActive == 1 ? "Vendor Wise Inactive Age Breakdown" : `${props.title}`}`
                    }
                </span>

                <div className="flex items-center gap-2">
                  {props.flag === 3 && currentView !== "summary" && (
                    <button
                      onClick={currentView === "priceline" ? handleBackToAge : handleBackToSummary}
                      className="back-btn inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-[#f4faea]  text-[#339900]  hover:bg-[#d1e7c6]  border border-[#84c225] chart-title font-semibold"
                    >
                      <span aria-hidden>←</span>
                      <span className="chart-title">{currentView === "priceline" ? "Back to Age Breakdown" : "Back to Summary"}</span>
                    </button>
                  )}

                  {props.flag == 1 && (
                    <div className="flex gap-[2px]">
                      <div
                        onClick={() => setIsActive(0)}
                        className={`${isActive == 0 ? "bg-deloitteGreen" : "bg-[#949494]"} rounded-tl-md rounded-bl-md p-[2px] pb-[3px] pr-[3px] flex h-[16px] items-center text-white cursor-pointer`}
                      >
                        <span className={isActive == 0 ? "text-fs14 text-white font-semibold" : "text-fs14 font-semibold"}>Cluster</span>
                      </div>
                      <div
                        onClick={() => setIsActive(1)}
                        className={`${isActive == 1 ? "bg-deloitteGreen" : "bg-[#949494]"} rounded-tr-md rounded-br-md p-[2px] pb-[3px] pr-[3px] flex h-[16px] items-center text-white cursor-pointer`}
                      >
                        <span className={isActive == 1 ? "text-fs14 text-white font-semibold" : "text-fs14 font-semibold"}>Vendor</span>
                      </div>
                    </div>
                  )}
                </div>
            </div>

            <div className="flex h-[30vh]">
                {/* NEW: Flag=3 drill-through functionality */}
                {props.flag == 3 && (
                    <div className="flex-grow h-full">                        
                        {/* Loading state */}
                        {loading && (
                            <div className="flex items-center justify-center h-full">
                                <span>Loading...</span>
                            </div>
                        )}
                        
                        {/* Chart rendering based on current view */}
                        {!loading && currentView === 'summary' && renderSummaryChart()}
                        {!loading && currentView === 'age' && renderAgeChart()}
                        {!loading && currentView === 'priceline' && renderPriceLineChart()}
                        
                        {/* Click hints */}
                        {/* {!loading && currentView !== 'devalued' && (
                            <p className="text-xs text-gray-500 mt-2 text-center">
                                Click on a bar to drill down
                            </p>
                        )} */}
                    </div>
                )}

                {/* Existing flag=1 functionality */}
              {props.flag == 1 && isActive == 0 && <div className="flex-grow h-full">
                  <ResponsiveContainer width={"100%"} height={"100%"}>
                      <ComposedChart data={graphDataAge} margin={{ top: 20, right: 20, bottom: 0, left: 10 }}>
                          <XAxis 
                            fontSize={"0.8vw"} 
                            dataKey="cluster" 
                            stroke="#949494"  />
                          <YAxis stroke="#949494" fontSize={"0.8vw"} tickCount={10} tickFormatter={formatter}
                          interval="equidistantPreserveStart" />
                          <Tooltip content={<CustomTooltip/>} />
                          <Legend
                              content={<CustomLegend />}
                              align="left"
                              verticalAlign="top"
                              iconSize={8}
                              wrapperStyle={{ left: 0, top: 0, marginBottom: "10px" }}
                          />
                          <Bar
                            name=">12 Months"
                            dataKey="M8"
                            stroke="#DC9090"
                            fill="#DC9090"
                            stackId="a"
                            maxBarSize={30}
                          />
                          <Bar
                            name="8-12 Months"
                            dataKey="M812"
                            stroke="#62B5E5"
                            fill="#62B5E5"
                            stackId="a"
                            maxBarSize={30}
                          />
                      </ComposedChart>
                  </ResponsiveContainer>
              </div>}
              {props.flag == 1 && isActive == 1 && <div className="flex-grow h-full">
                <ResponsiveContainer width={"100%"} height={"100%"}>
                  <ComposedChart data={vendorAgeData} margin={{ top: 20, right: 20, bottom: 0, left: -10 }}>
                    <XAxis fontSize={"0.8vw"} dataKey="cluster" stroke="#949494" />
                    <YAxis interval="equidistantPreserveStart" stroke="#949494" fontSize={"0.8vw"} tickCount={10} tickFormatter={formatter} />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend
                      content={<CustomLegend />}
                      align="left"
                      verticalAlign="top"
                      iconSize={8}
                      className="font-semibold"
                      wrapperStyle={{ left: 0, top: 0, marginBottom: "10px" }}
                    />
                    <Bar
                      name=">12 Months"
                      dataKey="M8"
                      stroke="#DC9090"
                      fill="#DC9090"
                      stackId="b"
                      maxBarSize={30}
                    />
                    <Bar
                      name="8-12 Months"
                      dataKey="M812"
                      stroke="#62B5E5"
                      fill="#62B5E5"
                      stackId="b"
                      maxBarSize={30}
                    />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>}

                {/* Existing flag=2 functionality */}
                {props.flag == 2 && <div className="flex-grow h-full">
                    <ResponsiveContainer width={"100%"} height={"100%"}>
                        <ComposedChart data={dohData} margin={{ top: 20, right: 20, bottom: 0, left: -10 }}>
                            <XAxis fontSize={"0.8vw"} dataKey="plant_code" stroke="#949494"  />
                            <YAxis interval="equidistantPreserveStart" stroke="#949494" yAxisId="left" fontSize={"0.8vw"} tickCount={10} tickFormatter={formatter} />
                            <YAxis interval="equidistantPreserveStart" stroke="#949494" yAxisId="right" orientation="right" fontSize={"0.8vw"} tickCount={10} />
                            <Tooltip content={<CustomTooltip/>} />
                            <Legend
                                content={<CustomLegend />}
                                align="left"
                                verticalAlign="top"
                                iconSize={8}
                                wrapperStyle={{ left: 0, top: 0, marginBottom: "10px" }}
                            />
                            <Bar
                                name="OnHand (Qty.)"
                                dataKey="onhand"
                                fill="#949494"
                                yAxisId="left"
                                maxBarSize={30}
                            />
                            <Line
                                connectNulls={true}
                                name="DOH"
                                dataKey="doh"
                                stroke="#62B5E5"
                                fill="#62B5E5"
                                strokeWidth={2}
                                dot={{ strokeWidth: 1, r: 2 }}
                                yAxisId="right"
                                activeDot={{stroke:'#62B5E5', fill: 'white', strokeWidth:2, r: 4}}
                            />
                        </ComposedChart>
                    </ResponsiveContainer>
                </div>}
            </div>
        </div>
    );
}

// Custom legend for stacked charts
const CustomLegend = ({ payload }: any) => {
  // Filter out the base layer from legend
  const filteredPayload = payload.filter(
    (entry: { name?: string; color?: string }) => 
      entry.name !== 'base' && entry.color !== 'transparent'
  );

  return (
    <ul className="flex items-center gap-2">
      {filteredPayload.map((entry: any, index: number) => (
        <li key={`item-${index}`} className="flex items-center">
          <svg width="10" height="10">
            <rect x="0" y="0" width="10" height="10" fill={entry.color} />
          </svg>
          <span style={{ color: entry.color }} className="ml-2 font-semibold font-[0.6vw]">
            {entry.value === "onHand" ? "On Hand (Qty.)" :
             entry.value === "onhand" ? "On Hand (Qty.)" :
             entry.value === "effectivess" ? "Safety Stock (Qty.)" :
             entry.value === "adjusted" ? "Safety Stock (Qty.) + Cycle Stock (Qty.)" :
             entry.value}
          </span>
        </li>
      ))}
    </ul>
  );
};

// Custom tooltip for waterfall charts
const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length) {
    // Filter out the base layer from tooltip
  const filteredPayload = payload.filter(
    (entry: { name?: string; color?: string }) => 
      entry.name !== 'base' && entry.color !== 'transparent'
  );

    return (
      <div className="bg-[#fff] border-[1px] border-[#BEBEBE] p-2 rounded rs-bg">
        {payload[0]?.payload?.monthStartDate && payload[0]?.payload?.monthdate && (
          <p className="text-black text-fs16 font-bold mb-3">
            {payload[0]?.payload?.monthStartDate ||
              payload[0]?.payload?.monthdate}
          </p>
        )}
        <div className="flex flex-col gap-2">
          {filteredPayload.map((entry: any) => (
            <div className="flex flex-col" key={entry?.name}>
              <p className="text-black text-fs14">
                {entry.name === "onHand" 
                  ? "On Hand (Qty.)" 
                  : entry.name === "onhand" 
                    ? "On Hand (Qty.)" 
                    : entry.name}
              </p>
              <p 
                style={{ color: entry.color }} 
                className="text-black text-fs20 font-bold"
              >
                {entry.payload.type === 'negative' 
                  ? `-$${formatter(Math.abs(entry.value))}` 
                  : `$${formatter(entry.value)}`}
              </p>
            </div>
          ))}
        </div>
      </div>
    );
  }
  return null;
};
export default LineGraph;
